function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_926",
  "data-name": "Group 926",
  transform: "translate(0.346 0.25)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_169",
  "data-name": "Path 169",
  d: "M8.469,0a4.471,4.471,0,0,1,4.464,4.516A4.556,4.556,0,0,1,10.884,8.3a8.513,8.513,0,0,1,6.091,7.247c.105.945-1.47,1-1.575.158a7,7,0,0,0-13.916,0c-.105.84-1.68.788-1.575-.158A8.643,8.643,0,0,1,6.053,8.3,4.494,4.494,0,0,1,8.469,0Zm0,1.575a2.915,2.915,0,1,0,2.888,2.941A2.936,2.936,0,0,0,8.469,1.575Z",
  transform: "translate(0)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.5
}));

var SvgYourPostsIcon = function SvgYourPostsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.578,
    height: 16.796,
    viewBox: "0 0 17.578 16.796",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYourPostsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/your-posts-icon.1a02c061.svg";
export { ForwardRef as ReactComponent };